window.addEventListener('DOMContentLoaded', (event) => {
  // 閲覧履歴(localStorageを使用)
  const currentUrl = window.location.href;

  // article_detail
  const articlePattern = /\/article\/detail\/(\d+)/
  const matchArticle = currentUrl.match(articlePattern)
  if (matchArticle) {
    let articleHistory = localStorage.getItem('articleHistory')
    if (articleHistory) {
      // 閲覧履歴がある場合、JSONパースして配列に変換
      articleHistory = JSON.parse(articleHistory)
    } else {
      articleHistory = []
    }

    const articleId = Number(matchArticle[1])
    // 既にIDが存在する場合は削除する
    const index = articleHistory.indexOf(articleId)
    if (index !== -1) {
      articleHistory.splice(index, 1)
    }
    // localStorageに保存(上限50)
    addLimited(articleHistory, articleId, 50);
    localStorage.setItem('articleHistory', JSON.stringify(articleHistory));
  }

  // movie_detail
  const moviePattern = /\/movie\/detail\/(\d+)/
  const matchMovie = currentUrl.match(moviePattern)
  if (matchMovie) {
    let movieHistory = localStorage.getItem('movieHistory')
    if (movieHistory) {
      // 閲覧履歴がある場合、JSONパースして配列に変換
      movieHistory = JSON.parse(movieHistory)
    } else {
      movieHistory = []
    }

    const movieId = Number(matchMovie[1])
    // 既にIDが存在する場合は削除する
    const index = movieHistory.indexOf(movieId)
    if (index !== -1) {
      movieHistory.splice(index, 1)
    }
    // localStorageに保存(上限50)
    addLimited(movieHistory, movieId, 50);
    localStorage.setItem('movieHistory', JSON.stringify(movieHistory));
  }

  // gift_detail
  const giftPattern = /\/gift\/detail\/(\d+)/
  const matchGift = currentUrl.match(giftPattern)
  if (matchGift) {
    let giftHistory = localStorage.getItem('giftHistory')
    if (giftHistory) {
      // 閲覧履歴がある場合、JSONパースして配列に変換
      giftHistory = JSON.parse(giftHistory)
    } else {
      giftHistory = []
    }

    const giftId = Number(matchGift[1])
    // 既にIDが存在する場合は削除する
    const index = giftHistory.indexOf(giftId)
    if (index !== -1) {
      giftHistory.splice(index, 1)
    }
    // localStorageに保存(上限50)
    addLimited(giftHistory, giftId, 50);
    localStorage.setItem('giftHistory', JSON.stringify(giftHistory));
  }

  // shop_detail_top
  const shopPattern = /\/shop\/(\d+)\/(\d+)\/top/
  const matchShop = currentUrl.match(shopPattern)
  if (matchShop) {
    let shopHistory = localStorage.getItem('shopHistory')
    if (shopHistory) {
      // 閲覧履歴がある場合、JSONパースして配列に変換
      shopHistory = JSON.parse(shopHistory)
    } else {
      shopHistory = []
    }

    const shopId = Number(matchShop[2])
    // 既にIDが存在する場合は削除する
    const index = shopHistory.indexOf(shopId)
    if (index !== -1) {
      shopHistory.splice(index, 1)
    }
    // localStorageに保存(上限50)
    addLimited(shopHistory, shopId, 50);
    localStorage.setItem('shopHistory', JSON.stringify(shopHistory));
  }

  function addLimited(array, value, limit) {
      array.unshift(value)
      array.splice(limit)
  }

  // changeTab
  const historyPage = document.querySelector('.favorites.history')
  if (historyPage) {
    const shop = document.getElementById('shop')
    const article = document.getElementById('article')
    const movie = document.getElementById('movie')
    const gift = document.getElementById('gift')
    const shopList = document.querySelector('.shopList')
    const articleList = document.querySelector('.articleList')
    const movieList = document.querySelector('.movieList')
    const giftList = document.querySelector('.giftList')

    shop.addEventListener('click', () => {
      shop.classList.add('active')
      article.classList.remove('active')
      movie.classList.remove('active')
      gift.classList.remove('active')
      shopList.style.display = 'block'
      articleList.style.display = 'none'
      movieList.style.display = 'none'
      giftList.style.display = 'none'
    })
    article.addEventListener('click', () => {
      shop.classList.remove('active')
      article.classList.add('active')
      movie.classList.remove('active')
      gift.classList.remove('active')
      shopList.style.display = 'none'
      articleList.style.display = 'block'
      movieList.style.display = 'none'
      giftList.style.display = 'none'
    })
    movie.addEventListener('click', () => {
      shop.classList.remove('active')
      article.classList.remove('active')
      movie.classList.add('active')
      gift.classList.remove('active')
      shopList.style.display = 'none'
      articleList.style.display = 'none'
      movieList.style.display = 'block'
      giftList.style.display = 'none'
    })
    gift.addEventListener('click', () => {
      shop.classList.remove('active')
      article.classList.remove('active')
      movie.classList.remove('active')
      gift.classList.add('active')
      shopList.style.display = 'none'
      articleList.style.display = 'none'
      movieList.style.display = 'none'
      giftList.style.display = 'block'
    })
  }
})
